window.customElements.define("fostr-megamenu", class FostrMegamenu extends HTMLElement {

    megamenuCurrentClass = 'megamenu--current';
    megamenuVisibleClass = 'megamenu--isVisible';
    megamenuAnimateClass = 'megamenu--animate';
    bodyClass = 'megamenu--isActive';
    megamenuElClass = '[id^=shopify-section-fostr-header] #megamenu';
    mainNavTarget = 'header .header__menu-item';
    curtainTarget = 'fostr-megamenu-curtain';
    megamenuEl = null;
    timer = null;
    menuLinkHoverDuration = 150;
    currently_opening = false;

    constructor() {
        super();
    }

    connectedCallback() {
      this.addCurtain();
      this.addMeganavToHeader();

      // Event listeners
      this.windowEventScroll();
      this.linkEventMouseover();
      this.curtainEventClick();
      this.linkEventMouseout();
      this.curtainEventMouseover();
    }

    disconnectedCallback() {
      if (this.megamenuEl) this.megamenuEl.remove();
    }

    // Methods
    addCurtain() {
      if (document.getElementById('megamenu')) return;
      this.innerHTML = '<fostr-megamenu-curtain></fostr-megamenu-curtain>' + this.innerHTML;
    }

    addMeganavToHeader() {
      document.querySelector('[id^=shopify-section-fostr-header] .header-wrapper').insertAdjacentHTML('afterend', this.innerHTML)
      this.innerHTML = '';
      this.megamenuEl = document.querySelector(this.megamenuElClass);
    }

    removeAnimation() {
      this.megamenuEl.classList.remove(this.megamenuAnimateClass);
      document.body.classList.remove(this.bodyClass);
    }

    showMegamenuItem(menuItemEl) {
      if (!menuItemEl) return;

      const desktopSearchOpenEl = document.querySelector("details[open]");
      if (desktopSearchOpenEl) return;
      let megamenuId = "megamenu-" + menuItemEl.dataset.handle.trim();
      let megamenuItemEl = document.getElementById(megamenuId);

      if (!megamenuItemEl) {
        this.hideAllMenuItems();
        this.removeAnimation();
        clearTimeout(this.timer);
        return;
      }

      let timerHoverDuration = (this.menuIsVisible()) ? 0 : this.menuLinkHoverDuration;

      let self = this;
      this.timer = setTimeout(function() {
        // prepare menu for animation
        document.body.classList.add(self.bodyClass);
        self.megamenuEl.classList.add(self.megamenuAnimateClass);

        // show mega menu item
        setTimeout(function() {
          self.hideAllMenuItems();
          menuItemEl.classList.add(self.megamenuCurrentClass);
          megamenuItemEl.classList.add(self.megamenuVisibleClass);
          self.currently_opening = false;
        }, 250)
      }, timerHoverDuration);
    }

    hideAllMenuItems() {
      // hide mega menu item
      let currentMenuItems = document.querySelectorAll('.' + this.megamenuCurrentClass);
      if (currentMenuItems) {
        for (var i=0; i < currentMenuItems.length; i++) {
          let currentMenuItem = currentMenuItems[i];
          currentMenuItem.classList.remove(this.megamenuCurrentClass);
        }
      };

      let visibleMenuItems = document.querySelectorAll('.' + this.megamenuVisibleClass);
      if (visibleMenuItems) {
        for (var i=0; i < visibleMenuItems.length; i++) {
          let visibleMenuItem = visibleMenuItems[i];
          visibleMenuItem.classList.remove(this.megamenuVisibleClass);
        }
      };
    }

    menuIsVisible() {
      return (document.querySelector('#megamenu.megamenu--animate')) ? true : false;
    }

    // Event Listeners
    curtainEventClick() {
      const self = this;
      document.addEventListener('click', function(e) {
        if (!e.target.closest(self.curtainTarget)) return false;
        self.hideAllMenuItems();
        self.removeAnimation();
      });
    }

    curtainEventMouseover() {
      const self = this;
      document.addEventListener('mouseover', function(e) {
        if (!e.target.closest(self.curtainTarget)) return false;
        if (!self.menuIsVisible()) return;

        if( !self.currently_opening ) {
          clearTimeout(self.timer);
          self.hideAllMenuItems();
          self.removeAnimation();
        }
      });
    }

    windowEventScroll() {
      const self = this;
      window.addEventListener('scroll', function(e) {
        self.hideAllMenuItems();
        self.removeAnimation();
      })
    }

    linkEventMouseover() {
      const self = this;
      document.addEventListener('mouseover', function(e) {
        if (!e.target.closest(self.mainNavTarget)) return false;
        self.currently_opening = true;
        self.showMegamenuItem(e.target);
      });
    }

    linkEventMouseout() {
      const self = this;
      document.addEventListener('mouseout', function(e) {
        if( !self.currently_opening ) {
          if (!e.target.closest(self.mainNavTarget)) return false;
          clearTimeout(self.timer);
        }
      });
    }
})
